import { createSlice } from '@reduxjs/toolkit';

const PAGE_SIZE = 50;

const initialState = {
  date: '',
  price_init: '',
  price_final: '',
  event_type: '',
  event_category: '',
  event_city: '',
  event_name: '',
  offset: 0,
  limit: PAGE_SIZE,
};

const slice = createSlice({
  name: 'billboardFilters',
  initialState,
  reducers: {
    setFilters: (state, { payload }) => payload,
    setFilterDate: (state, { payload }) => ({
      ...state,
      date: payload,
      offset: 0,
      limit: PAGE_SIZE,
    }),
    setFilterPriceInit: (state, { payload }) => ({
      ...state,
      price_init: payload,
      offset: 0,
      limit: PAGE_SIZE,
    }),
    setFilterPriceFinal: (state, { payload }) => ({
      ...state,
      price_final: payload,
      offset: 0,
      limit: PAGE_SIZE,
    }),
    setFilterEventType: (state, { payload }) => ({
      ...state,
      event_type: payload,
      offset: 0,
      limit: PAGE_SIZE,
    }),
    setFilterEventCategory: (state, { payload }) => ({
      ...state,
      event_category: payload,
      offset: 0,
      limit: PAGE_SIZE,
    }),
    setFilterEventCity: (state, { payload }) => ({
      ...state,
      event_city: payload,
      offset: 0,
      limit: PAGE_SIZE,
    }),
    setFilterEventName: (state, { payload }) => ({
      ...state,
      event_name: payload,
      offset: 0,
      limit: PAGE_SIZE,
    }),
    setFilterOffset: (state, { payload }) => ({
      ...state,
      offset: payload,
    }),
    setFilterLimit: (state, { payload }) => ({
      ...state,
      limit: payload,
    }),
    increeaseOffset: (state, { payload }) => ({
      ...state,
      offset: state.offset + state.limit,
    }),
    restore: () => initialState,
  },
});

export const {
  setFilters,
  restore,
  setFilterDate,
  setFilterPriceInit,
  setFilterPriceFinal,
  setFilterEventType,
  setFilterEventCategory,
  setFilterEventCity,
  setFilterEventName,
  setFilterLimit,
  setFilterOffset,
  increeaseOffset,
} = slice.actions;

export default slice.reducer;

export { PAGE_SIZE };
